var map = {
	"./aff.png": "./openbrix-design-system/images/banner/web/aff.png",
	"./cb.png": "./openbrix-design-system/images/banner/web/cb.png",
	"./dashboard.png": "./openbrix-design-system/images/banner/web/dashboard.png",
	"./document.png": "./openbrix-design-system/images/banner/web/document.png",
	"./happy.png": "./openbrix-design-system/images/banner/web/happy.png",
	"./id.png": "./openbrix-design-system/images/banner/web/id.png",
	"./market.png": "./openbrix-design-system/images/banner/web/market.png",
	"./my-account.png": "./openbrix-design-system/images/banner/web/my-account.png",
	"./openflow.png": "./openbrix-design-system/images/banner/web/openflow.png",
	"./ref.png": "./openbrix-design-system/images/banner/web/ref.png",
	"./rewards.png": "./openbrix-design-system/images/banner/web/rewards.png",
	"./rtr.png": "./openbrix-design-system/images/banner/web/rtr.png",
	"./ti.png": "./openbrix-design-system/images/banner/web/ti.png",
	"./tp.png": "./openbrix-design-system/images/banner/web/tp.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./openbrix-design-system/images/banner/web sync recursive ^\\.\\/.*$";